/* Built In Imports */
import config from '@config';
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Configs */
import { ResearchShowsSt } from '@ieo/Common/CompLangConfig';

/* Styles */
/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import SingleImage from './SingleImage';
/**
 *
 * @param {Object} sectionContent
 * @param {string} region
 * @param {string} lang
 * @returns {ReactElement} component
 */
const DescriptionV8 = ({ sectionContent, lang }) => {
  return (
    <Box
      w={{ base: '100%', md: '100%' }}
      px={{ base: '16px', sm: '20px', md: '30px', xl: '0px' }}
      pt={{ base: '8px', md: '40px', lg: '80px' }}
      pb={{ base: '55px', md: '80px', lg: '120px' }}
      mx="auto"
    >
      <Box
        maxW={{
          base: '100%',
          xl: 1050,
          '2xl': '1036px',
        }}
        w="100%"
        mx="auto"
      >
        <Box
          display="flex"
          gap={{ base: '30px', lg: '60px' }}
          justifyContent="space-between"
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          flexDirection={{ base: 'column', md: 'row' }}
          alignItems={{ base: 'flex-start', md: 'center' }}
        >
          <Box display={{ base: 'block', md: 'none' }} position="relative">
            {searchByFieldId(sectionContent, 'ie-heading-v5') && (
              <Text
                fontFamily="FedraSansStd-medium"
                fontSize={{ base: '32px', md: '64px' }}
                color="#3B444B"
                display={{ base: 'block', md: 'none' }}
                lineHeight={{ base: '38px', md: '64px' }}
              >
                {searchByFieldId(sectionContent, 'ie-heading-v5').text}
              </Text>
            )}
          </Box>
          <SingleImage
            w="100%"
            h="100%"
            sectionContent={sectionContent[2]}
            px={'0px'}
            my={'0px'}
          />

          <Box>
            <StructuredTextParser
              str={render(sectionContent[3]?.body)}
              fontFamily="FedraSansStd-book"
              className="innerEngineeringDesText"
              fontSize={{ base: '16px', md: '18px' }}
              lineHeight={{ base: '25px', xl: '27px' }}
              textAlign={lang === 'ar' ? 'right' : 'left'}
              pt={{ base: '5px', lg: '5px' }}
              color="#6D6358"
              display={{ base: 'block', md: 'none' }}
              my={'0px'}
              mb={'30px'}
            />
            <Box>
              {searchByFieldId(sectionContent, 'ie-heading-v5') && (
                <Text
                  lineHeight={{ base: '38px', md: '64px' }}
                  fontFamily="FedraSansStd-medium"
                  fontSize={{ base: '32px', md: '64px' }}
                  color="#3B444B"
                  display={{ base: 'none', md: 'block' }}
                >
                  {searchByFieldId(sectionContent, 'ie-heading-v5').text}
                </Text>
              )}
              <StructuredTextParser
                str={render(sectionContent[3]?.body)}
                fontFamily="FedraSansStd-book"
                className="innerEngineeringDesText"
                fontSize={{ base: '16px', md: '18px' }}
                lineHeight={{ base: '25px', xl: '27px' }}
                textAlign={lang === 'ar' ? 'right' : 'left'}
                pt={{ base: '23px' }}
                color="#6D6358"
                display={{ base: 'none', md: 'block' }}
                my={'0px'}
                mt={'0px'}
              />

              <StructuredTextParser
                str={render(sectionContent[1]?.body)}
                fontFamily="FedraSansStd-book"
                className="innerEngineeringText"
                fontSize={{ base: '16px', md: '18px' }}
                lineHeight={{ base: '24px', xl: '27px' }}
                textAlign={lang === 'ar' ? 'right' : 'left'}
                mt={{ base: '16px', lg: '23px' }}
                color="#6D6358"
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <style global jsx>
        {`
          .innerEngineeringDesText p:last-child {
            padding-top: 10px;
          }
          @media (width >= 768px) {
            .innerEngineeringDesText p:last-child {
              padding-top: 18px;
            }
          }
          .innerEngineeringText mark {
            color: #3b444b;
            font-family: ${ResearchShowsSt[lang]?.heading?.fontFamily};
            background: none;
          }

          .innerEngineeringText ul {
            list-style-type: none;
            padding-left: 29px;
          }
          .innerEngineeringText ul li:first-child {
            padding-top: 0 !important;
          }
          .innerEngineeringText ul li:first-child::before {
            top: 0 !important;
          }
          .innerEngineeringText ul li {
            position: relative;
            padding-left: 14px;
            padding-top: 14px;
          }
          .innerEngineeringText ul li::before {
            position: absolute;
            content: '';
            left: -30px;
            top: 14px;
            width: 20px;
            height: 20px;
            background: url(${config.imgPath}/d/46272/1706007377-44.png);
            background-repeat: no-repeat;
            margin-top: 7px;
          }
          .innerEngineeringText p {
            color: #323232;
            font-family: FedraSansStd-book;
            font-weight: normal;
          }
          .innerEngineeringText p strong {
            color: #12166f;
            font-family: FedraSansStd-medium;
            font-weight: normal;
          }
        `}
      </style>
    </Box>
  );
};

export default DescriptionV8;
